/* SPOTEC Panduan Ukuran — buka/tutup panel, tab Pria/Wanita/Anak (sepatu) atau pilih ukuran + cm/inci (kaos),
   dan tandai ukuran yang sedang dipilih di halaman produk. */
(() => {
  if (window.__spxSizeGuide) return;
  window.__spxSizeGuide = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const html = document.documentElement;
  let opener = null;
  let closing = 0;

  const dialog = () => document.getElementById('SpxSizeGuide');

  function selectTab(dlg, key, focus) {
    dlg.querySelectorAll('[data-spx-sg-tab]').forEach((tab) => {
      const on = tab.dataset.spxSgTab === key;
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
      if (on && focus) tab.focus();
    });
    dlg.querySelectorAll('[data-spx-sg-pane]').forEach((pane) => { pane.hidden = pane.dataset.spxSgPane !== key; });
  }

  // Ukuran yang sedang dipilih di halaman produk (mis. "38", "EUR 38", "38.5").
  function currentSize(trigger) {
    const set = trigger && trigger.closest('fieldset');
    const checked = set && set.querySelector('input[type="radio"]:checked');
    const select = !checked && set && set.querySelector('select');
    const raw = checked ? checked.value : select ? select.value : '';
    const letter = String(raw).trim().toUpperCase();
    if (/^(XXS|XS|S|M|L|XL|XXL|2XL|XXXL|3XL)$/.test(letter)) return letter;   // kaos / atasan
    const m = String(raw).match(/(\d{2}(?:[.,]5)?)/);
    return m ? m[1].replace(',', '.') : '';
  }

  /* ---------- Kaos: pilih ukuran → angka besar, dan satuan cm / inci ---------- */
  const toNum = (v) => parseFloat(String(v).replace(',', '.'));
  const fmt = (cm, unit) => {
    if (unit !== 'in') return String(cm).replace(',', '.');
    const v = toNum(cm) / 2.54;
    return (Math.round(v * 10) / 10).toString();
  };
  function teeUnit(dlg) { const b = dlg.querySelector('[data-spx-tee-unit][aria-pressed="true"]'); return b ? b.dataset.spxTeeUnit : 'cm'; }
  function teePick(dlg, size) {
    const chips = [...dlg.querySelectorAll('[data-spx-tee-size]')];
    const chip = chips.find((c) => c.dataset.spxTeeSize === size) || chips.find((c) => c.dataset.spxTeeSize === 'M') || chips[0];
    if (!chip) return;
    const unit = teeUnit(dlg);
    chips.forEach((c) => { const on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', String(on)); });
    ['bahu', 'dada', 'panjang'].forEach((k) => { const el = dlg.querySelector(`[data-spx-tee-v="${k}"]`); if (el) el.textContent = fmt(chip.dataset[k], unit); });
    dlg.querySelectorAll('tr.is-current').forEach((tr) => tr.classList.remove('is-current'));
    dlg.querySelectorAll(`tr[data-eur="${chip.dataset.spxTeeSize}"]`).forEach((tr) => tr.classList.add('is-current'));
  }
  function teeSetUnit(dlg, unit) {
    dlg.querySelectorAll('[data-spx-tee-unit]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.spxTeeUnit === unit)));
    dlg.querySelectorAll('td[data-cm]').forEach((td) => { td.textContent = fmt(td.dataset.cm, unit); });
    dlg.querySelectorAll('[data-spx-unit]').forEach((el) => { el.textContent = unit === 'in' ? 'in' : 'cm'; });
    const active = dlg.querySelector('[data-spx-tee-size].is-active');
    if (active) teePick(dlg, active.dataset.spxTeeSize);
  }

  function open(trigger) {
    const dlg = dialog();
    if (!dlg || dlg.open) return;
    clearTimeout(closing);
    opener = trigger;
    const size = currentSize(trigger);
    dlg.querySelectorAll('tr.is-current').forEach((tr) => tr.classList.remove('is-current'));
    if (size) dlg.querySelectorAll(`tr[data-eur="${size}"]`).forEach((tr) => tr.classList.add('is-current'));
    if (dlg.dataset.mode === 'apparel') teePick(dlg, size);
    const active = dlg.querySelector('[data-spx-sg-tab][aria-selected="true"]');
    selectTab(dlg, active ? active.dataset.spxSgTab : dlg.dataset.default || 'men');
    dlg.showModal();
    html.classList.add('spx-sg-lock');
    dlg.querySelector('.spx-sg__body').scrollTop = 0;
    requestAnimationFrame(() => requestAnimationFrame(() => dlg.classList.add('is-open')));
  }

  function close() {
    const dlg = dialog();
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('is-open');
    html.classList.remove('spx-sg-lock');
    closing = setTimeout(() => {
      dlg.close();
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    }, reduce.matches ? 0 : 420);
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-spx-sg-open]');
    if (trigger) { e.preventDefault(); open(trigger); return; }
    const dlg = dialog();
    if (!dlg || !dlg.open) return;
    if (e.target.closest('[data-spx-sg-close]') || e.target === dlg) { close(); return; }
    const tab = e.target.closest('[data-spx-sg-tab]');
    if (tab && dlg.contains(tab)) selectTab(dlg, tab.dataset.spxSgTab);
    const chip = e.target.closest('[data-spx-tee-size]');
    if (chip && dlg.contains(chip)) teePick(dlg, chip.dataset.spxTeeSize);
    const unit = e.target.closest('[data-spx-tee-unit]');
    if (unit && dlg.contains(unit)) teeSetUnit(dlg, unit.dataset.spxTeeUnit);
    const row = e.target.closest('.spx-tee__table tbody tr');
    if (row && dlg.contains(row)) teePick(dlg, row.dataset.eur);
  });

  document.addEventListener('keydown', (e) => {
    const dlg = dialog();
    if (!dlg || !dlg.open) return;
    const tab = e.target.closest && e.target.closest('[data-spx-sg-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
    const tabs = [...dlg.querySelectorAll('[data-spx-sg-tab]')];
    let i = tabs.indexOf(tab);
    if (e.key === 'ArrowRight') i = (i + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') i = 0;
    else i = tabs.length - 1;
    e.preventDefault();
    selectTab(dlg, tabs[i].dataset.spxSgTab, true);
  });

  // Esc: tutup dengan animasi (bukan langsung hilang).
  document.addEventListener('cancel', (e) => {
    if (e.target && e.target.id === 'SpxSizeGuide') { e.preventDefault(); close(); }
  }, true);
  window.addEventListener('pageshow', (e) => { if (e.persisted) { const d = dialog(); if (d && d.open) { d.classList.remove('is-open'); d.close(); html.classList.remove('spx-sg-lock'); } } });
})();
